import {
  ADD_COMMERCIAL_PROPOSAL,
  UPDATE_COMMERCIAL_QUOTE,
  UPDATE_COMMERCIAL_QUOTE_FAILED,
  ADD_COMMERCIAL_PROPOSAL_FAILED,
  ADD_COMMERCIAL_QUOTE_FULFILLED,
  ADD_COMMERCIAL_QUOTE_REJECTED,
  ADD_COMMERCIAL_QUOTE_REQUESTED,
  ADD_INNER_COMMERCIAL_PROPOSAL,
  ADD_INNER_COMMERCIAL_PROPOSAL_FAILED,
  RESET_PROPOSAL,
  GET_COMMERCIAL_PROPOSAL,
  GET_COMMERCIAL_PROPOSAL_FAILED,
  GET_PROPOSAL_SUCCESSFULLY,
  GET_PROPOSAL_FAILED
} from '../Actions/types';

const INITIAL_STATE = {
  quote: {},
  loading: false,
  error: '',
  proposal: {},
  quote_info: {},
  addInnerProposal: {}
}

const commercialReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case ADD_COMMERCIAL_QUOTE_REQUESTED:
    return { ...state, loading: true, error: ''}
  case ADD_COMMERCIAL_QUOTE_REJECTED:
    return { ...state, error: action.payload, loading: false}
  case ADD_COMMERCIAL_QUOTE_FULFILLED:
    return { ...state, quote: action.payload, error: '',loading: false}
  case ADD_COMMERCIAL_PROPOSAL:
    return { ...state, proposal: action.payload, loading: false}
  case ADD_COMMERCIAL_PROPOSAL_FAILED:
    return { ...state, error: action.payload, loading: false}
  case UPDATE_COMMERCIAL_QUOTE:
    return { ...state, proposal: action.payload, loading: false}
  case UPDATE_COMMERCIAL_QUOTE_FAILED:
    return { ...state, error: action.payload, loading: false}
  case ADD_INNER_COMMERCIAL_PROPOSAL:
    return { ...state, addInnerProposal: action.payload, loading: false}
  case ADD_INNER_COMMERCIAL_PROPOSAL_FAILED:
    return { ...state, error: action.payload, loading: false}
  case RESET_PROPOSAL:
    return { ...state, quote: {}, proposal: {}, addInnerProposal: {}, loading: false}
  case GET_COMMERCIAL_PROPOSAL:
    return { ...state, proposal: action.payload, loading: false}
  case GET_COMMERCIAL_PROPOSAL_FAILED:
    return { ...state, error: action.payload, loading: false}
  case GET_PROPOSAL_SUCCESSFULLY:
    return { ...state, quote_info: action.payload, error: '',loading: false}
  case GET_PROPOSAL_FAILED:
    return { ...state, loading: true, error: ''}
  default:
    return { ...state }
  }
};

export default commercialReducer;